import TextFieldExtension from "../../@libs/TextFieldExtension";

import basicValidation from "../../validations/basic";
import required from "@libs/required";

class BasicTextField extends TextFieldExtension {
	constructor(...args) {
		super(...args);
	}

	get val() {
		return super.val;
	}

	get id() {
		return super.id;
	}

	get name() {
		return super.name;
	}

	get isValid() {
		return super.isValid;
	}

	validate(val = required`val`, customValidation) {
		return super.validate(
			val,
			customValidation || super.validation || basicValidation
		);
	}

	displayError(val = required`val`) {
		super.displayError(val);
	}
}

export default BasicTextField;
